/**
 * Human-readable message for a failed API mutation.
 *
 * Axios errors ARE `Error` instances, so a bare `err.message` shows the
 * useless "Request failed with status code 409" — the backend's actual reason
 * lives in `response.data.error`.
 *
 * Relocated from pages/IncidentManagement/apiError when Incident Management
 * moved to the investigator repo; Station Admin's IA policy-doc hook was the
 * other consumer.
 *
 * NOT replaceable by `apiErrorMessage` from shared/api/apiError, despite the
 * identical signature. That one runs `extractApiError`, which returns a null
 * message for anything `isAxiosError` rejects — so a plain `new Error("boom")`
 * comes back as the caller's generic fallback instead of "boom". The IA upload
 * flow surfaces exactly those non-axios failures inline, and
 * PolicyDocsCard.test.tsx ("surfaces a mint failure inline") fails if this is
 * swapped for the shared helper.
 */
export function mutationErrorMessage(err: unknown, fallback: string): string {
  const e = err as {
    response?: { data?: { error?: string } };
    message?: string;
  };
  return e?.response?.data?.error || e?.message || fallback;
}
